export default __webpack_public_path__ + "static/media/plusIcon.67d03d98.svg";